// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/feedback-" + chunkId + "." + {"1":"8dc0eb3d63b27e1a9484","2":"222b422eeb66d8c51c19","3":"3264eeae4849fe5f993c","4":"2c0bfb679301a6a93cc7","5":"55f062b0e2f8ebde287b","6":"3a4cd7512a933c565288"}[chunkId] + ".min.js";
};